const endpoints = {
  menu: "https://api.videogame-trailers.com/api/front/video-games-genre",
  games: "https://api.videogame-trailers.com/api/front/video-games",
  game: "https://api.videogame-trailers.com/api/front/video-game",
  gamesFirstGenre: 'https://api.videogame-trailers.com/api/front/video-games-first-genre',
  gamesSearch: 'https://api.videogame-trailers.com/api/front/video-games-search',
};

export { endpoints };
